import { forwardRef } from 'react'
import cx from 'classnames'
import { type PropertyValue } from 'api/clients/PropertyClient'
import { fillColor } from '../../PropertyForm/ColorInput'
import Styles from '../PropertyValue.module.scss'
import { isString } from 'lodash'
import { Tooltip } from 'components/Tooltip/Tooltip'

interface Props {
  propertyValue?: PropertyValue
  smallPill?: boolean
}

const SingleSelect = forwardRef<HTMLDivElement, Props>(({ propertyValue, smallPill = false }, ref) => {
  if (!isString(propertyValue?.value)) return <></>

  // for now, the only status disabled for edit is 'In Review'
  const disabledTooltipText = 'Status cannot be changed while a review is active'

  return (
    <Tooltip placement="top" label={propertyValue?.value_is_disabled ? disabledTooltipText : ``}>
      <div
        ref={ref}
        className={cx(Styles.singleSelectContainer, { [Styles.smallPill]: smallPill })}
        style={{
          backgroundColor: propertyValue?.meta?.color,
          color: fillColor(propertyValue?.meta?.color),
        }}
      >
        <span
          className={cx(Styles.pill, { [Styles.smallPill]: smallPill })}
          style={{ color: fillColor(propertyValue?.meta?.color) }}
        >
          {propertyValue?.value}
        </span>
      </div>
    </Tooltip>
  )
})

export default SingleSelect
